// import Vue from 'vue';

const userStore = {
    namespaced: true,
    state: {
        token: null,
        // isEligible: null
    },
    actions: {
        clearSession(state) {
            console.log(state);
        }
    },
    mutations: {
        updateUser(state, user) {
            state.token = user.token;
            // state.isEligible = user.isEligible;
        }
    },
    getters: {
        token: state => {
            console.log('userjs token');
            console.log(state);

            if (state.token === null) {
                console.log('bad token');
                return 'zEiWeCNvYNNlZxZiGgEro2Zu6VVPp4Y1CGdOKAAObx8=';
            }

            return state.token;
        },
        // isEligible: state => state.isEligible,
        tokenIsExpired: state => {
            if (state.token === null) {
                return true;
            }

            const body = state.token.split('.')[1];
            const decoded = JSON.parse(atob(body));
            let ts = Math.round((new Date()).getTime() / 1000);

            console.log('expiry:', decoded.exp, ts);
            console.log(state.token);

            return decoded.exp <= ts;
        },
        tokenNeedsRefresh: state => {
            const body = state.token.split('.')[1];
            const decoded = JSON.parse(atob(body));
            let ts = Math.round((new Date()).getTime() / 1000);

            return decoded.exp >= ts - 120;
        }
    }
}

export default userStore;
